import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=7260b058&scoped=true"
import script from "./welcome.vue?vue&type=script&lang=js"
export * from "./welcome.vue?vue&type=script&lang=js"
import style0 from "./welcome.vue?vue&type=style&index=0&id=7260b058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7260b058",
  null
  
)

export default component.exports